import { t } from 'i18next';
import { capitalize } from 'lodash';

import { ISubscriptionPlan, ISubscriptionRecurrent, SUBSCRIPTION_PLAN } from 'interfaces/subscriptions';

interface ISubscriptionCancelMessage {
  nextRecurrent: ISubscriptionRecurrent;
  currentRecurrent: ISubscriptionRecurrent;
  nextPlan: ISubscriptionPlan;
  currentPlan: ISubscriptionPlan;
  formattedDate: string;
}

export const getCancelSubscriptionMessage = ({
  nextRecurrent,
  currentRecurrent,
  nextPlan,
  currentPlan,
  formattedDate,
}: ISubscriptionCancelMessage): string => {
  const areNextAndCurrentPlanSame = nextRecurrent !== currentRecurrent && nextPlan === currentPlan;
  const isNotNextPlanFree = nextPlan !== currentPlan && nextPlan !== SUBSCRIPTION_PLAN.FREE;

  if (areNextAndCurrentPlanSame) {
    return t('subscriptionCancelDatePlan', { date: formattedDate, plan: t('monthlySubscription') });
  }

  if (isNotNextPlanFree) {
    return t('subscriptionCancelDatePlan', { date: formattedDate, plan: `"${capitalize(nextPlan)}" plan` });
  }

  return t('subscriptionCancelDate', { date: formattedDate });
};
